import React from 'react';
import Breadcrumbs from './Breadcrumbs';
import NotificationsPopup from './NotificationsPopup';

function MyNavBar() {



return (
  <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" data-scroll="true">

    <div className="container-fluid py-1 px-3">
      <nav aria-label="breadcrumb">
        {/*<ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
         
          --<li className="breadcrumb-item text-sm"> <Breadcrumbs/></li>
         
        --</ol>*/}
        <h6 className="font-weight-bolder mb-0"><Breadcrumbs/></h6>
      </nav>
      <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
        <div className="ms-md-auto pe-md-3 d-flex align-items-center">
          <div className="input-group input-group-outline">
            <label className="form-label">Type here...</label>
            <input type="text" className="form-control"/>
          </div>
        </div>
        <ul className="navbar-nav  justify-content-end">
          <li className="nav-item d-flex align-items-center">
            <a className="btn btn-outline-primary btn-sm mb-0 me-3" target="_blank" href="./dashboard.html">Search</a>
          </li>
          <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a href="#" className="nav-link text-body p-0" id="iconNavbarSidenav">
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
                <i className="sidenav-toggler-line"></i>
              </div>
            </a>
          </li>
          <li className="nav-item px-3 d-flex align-items-center">
            <a href="#" className="nav-link text-body p-0">
              <i className="fa fa-cog fixed-plugin-button-nav cursor-pointer"></i>
            </a>
          </li>
          <NotificationsPopup/>
          <li className="nav-item d-flex align-items-center">
            <a href="../pages/sign-in.html" className="nav-link text-body font-weight-bold px-0">
              
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
)
}

export default MyNavBar;